<div class="container">
  <h1>Hantera substudier</h1>
  <div *ngIf="subStudies | async as loadedSubStudies">
    <app-sub-studies-list [subStudies]="loadedSubStudies "></app-sub-studies-list>
  </div>
  <div>
    <a  mat-stroked-button  [routerLink]="'/sub-studies/new'">Lägg till</a>
  </div>
</div>
